/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryViewModel } from './categoryViewModel';
import { DisciplineViewModel } from './disciplineViewModel';
import { MasterViewModel } from './masterViewModel';
import { PunchMediaViewModel } from './punchMediaViewModel';
import { StatusViewModel } from './statusViewModel';
import { TopicViewModel } from './topicViewModel';
import { UserInfoViewModel } from './userInfoViewModel';

export interface PunchSimpleViewModel { 
    id?: number;
    code?: string;
    description?: string;
    topic?: TopicViewModel;
    discipline?: DisciplineViewModel;
    status?: StatusViewModel;
    category?: CategoryViewModel;
    originator?: MasterViewModel;
    userOriginator?: UserInfoViewModel;
    inspectionId?: number;
    closed?: boolean;
    createdBy?: string;
    createdAt?: Date;
    lastModifiedAt?: Date;
    notes?: string;
    cover?: PunchMediaViewModel;
    elements?: Array<MasterViewModel>;
}